export default __webpack_public_path__ + "static/media/2.665d0ff3.jpg";